import React from 'react';
import ReactDOM from "react-dom/client";
import { CssBaseline, ThemeProvider } from "@mui/material";
import Router from "./routes/Router.jsx";
import theme from "./theme/theme.js";
import { AiAssistSessionProvider } from './context/AiAssistSessionContext.jsx';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MsalProvider } from '@azure/msal-react';
import { authInstance, msalInitializationPromise } from './security/msalInstance.js';
import ApolloProviderGate from './providers/ApolloProviderGate.jsx';
import { initializeRuntimeMapConfig } from './services/runtimeMapConfig.js';
import logger from './utils/logger.js';
import AppBootstrapSpinner from './components/AppBootstrapSpinner.jsx';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));

const renderBootstrapSpinner = () => {
  root.render(
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppBootstrapSpinner />
    </ThemeProvider>
  );
};

const renderApp = () => {
  root.render(
    <MsalProvider instance={authInstance}>
      <AuthProvider>
        <NotificationProvider>
          <ApolloProviderGate>
            <AiAssistSessionProvider>
              <QueryClientProvider client={queryClient}>
                <ThemeProvider theme={theme}>
                  <CssBaseline />
                  <Router />
                </ThemeProvider>
              </QueryClientProvider>
            </AiAssistSessionProvider>
          </ApolloProviderGate>
        </NotificationProvider>
      </AuthProvider>
    </MsalProvider>,
  );
};

renderBootstrapSpinner();

const bootstrap = async () => {
  try {
    await msalInitializationPromise;

    // Resolve redirect first so account state is ready before tokenized bootstrap calls.
    const redirectResult = await authInstance.handleRedirectPromise();
    if (redirectResult?.account) {
      authInstance.setActiveAccount(redirectResult.account);
    }

    const accounts = authInstance.getAllAccounts();
    if (accounts.length > 0) {
      if (!authInstance.getActiveAccount()) {
        authInstance.setActiveAccount(accounts[0]);
      }
      await initializeRuntimeMapConfig();
    } else {
      logger.info('[GeoMap] Runtime map config bootstrap deferred until authentication completes.');
    }
  } finally {
    renderApp();
  }
};

bootstrap();



